import * as React from 'react'

type ActionForm = {
  hiddenInputs?: { [key: string]: string },
  children?: React.ReactNode,
  [param: string]: any, // TODO
}
export const ActionForm = ({ hiddenInputs = {}, children, ...otherProps }: ActionForm) => (
  <form {...otherProps} method="POST" >
    {children}
    {Object.keys(hiddenInputs).map((name, idx) =>
      <input key={`ActionFormImput-${idx}`} type="hidden" name={name} value={hiddenInputs[name]} />)
    }
  </form>
)